export default "__VITE_ASSET__BlA0qbTv__"